if (window.innerWidth > 768) {
    const slider = document.querySelector('.complete-the-look__products');

    if (document.querySelector('.complete-the-look__products') && document.querySelector('.complete-the-look__products').children.length > 3) {
        let isDown = false;
        let startX;
        let scrollLeft;
        
        slider.addEventListener('mousedown', (e) => {
          isDown = true;
          slider.classList.add('active');
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        });
        
        slider.addEventListener('mouseleave', (ev) => {
          isDown = false;
          slider.classList.remove('active');
          ev.stopPropagation();
        });
        
        slider.addEventListener('mouseup', () => {
          isDown = false;
          slider.classList.remove('active');
        });
        
        slider.addEventListener('mousemove', (e) => {
          if(!isDown) return;
          e.preventDefault();
          const x = e.pageX - slider.offsetLeft;
          const walk = (x - startX) * 3; //scroll-fast
          slider.scrollLeft = scrollLeft - walk;
        });
    }
}
